/**
 * Variant Quantity Limit
 * -----------------------
 * Enforces a maximum quantity of 1 for specific variants on the PDP.
 *
 * To restrict more variants in future, just add their numeric variant IDs
 * to the RESTRICTED_VARIANTS array below. Nothing else needs to change.
 *
 * (Cart page / cart drawer / AJAX enforcement is handled separately.)
 */
(function () {
  if (window.__variantQtyLimitInit) return;
  window.__variantQtyLimitInit = true;

  // === CONFIG: add restricted variant IDs here ===
  var RESTRICTED_VARIANTS = [42108174467118, 41467624357934];
  var MAX_QTY = 1;
  var MESSAGE = 'Only 1 quantity allowed for this product';
  // ================================================

  function isRestricted(variantId) {
    variantId = parseInt(variantId, 10);
    return RESTRICTED_VARIANTS.indexOf(variantId) !== -1;
  }

  // Read the currently selected variant ID from the main product form.
  function getSelectedVariantId() {
    var input = document.querySelector('[data-type="add-to-cart-form"] input[name="id"]');
    return input ? input.value : null;
  }

  // Single floating toast (fixed to the viewport, does not affect layout).
  function showToast() {
    var toast = document.querySelector('.variant-qty-limit__toast');
    if (!toast) {
      toast = document.createElement('div');
      toast.className = 'variant-qty-limit__toast';
      toast.setAttribute('role', 'status');
      toast.textContent = MESSAGE;
      document.body.appendChild(toast);
    }
    // Force reflow so the transition runs even on the first show.
    void toast.offsetWidth;
    toast.classList.add('is-visible');
    clearTimeout(toast.__hideTimer);
    toast.__hideTimer = setTimeout(function () {
      toast.classList.remove('is-visible');
    }, 2500);
  }

  // Apply / remove the limit on every quantity selector on the page,
  // based on the currently selected variant.
  function applyLimit() {
    var restricted = isRestricted(getSelectedVariantId());

    document.querySelectorAll('.product-form__quantity .quantity__input').forEach(function (input) {
      if (restricted) {
        input.setAttribute('max', MAX_QTY);
        if (parseInt(input.value, 10) > MAX_QTY) {
          input.value = MAX_QTY;
          input.dispatchEvent(new Event('change', { bubbles: true }));
        }
      } else {
        input.removeAttribute('max');
      }
    });
  }

  function init() {
    applyLimit();

    // Show the toast whenever the plus button is pressed on a restricted variant.
    // (The native max attribute already blocks the increment; this only messages.)
    document.addEventListener(
      'click',
      function (e) {
        var plusBtn = e.target.closest('.product-form__quantity button[name="plus"]');
        if (!plusBtn) return;
        if (!isRestricted(getSelectedVariantId())) return;

        showToast();
      },
      true
    );

    // Re-clamp if the shopper types a value manually.
    document.addEventListener('change', function (e) {
      if (!e.target.matches || !e.target.matches('.product-form__quantity .quantity__input')) return;
      if (!isRestricted(getSelectedVariantId())) return;
      if (parseInt(e.target.value, 10) > MAX_QTY) {
        e.target.value = MAX_QTY;
        showToast();
      }
    });

    // Re-evaluate whenever the variant selection changes on the PDP.
    var formInput = document.querySelector('[data-type="add-to-cart-form"] input[name="id"]');
    if (formInput) {
      new MutationObserver(applyLimit).observe(formInput, {
        attributes: true,
        attributeFilter: ['value'],
      });
    }
    // Variant selectors (radios/dropdowns/swatches) bubble a change event.
    document.addEventListener('change', function (e) {
      if (e.target.closest('variant-selects, variant-radios, .product-form__input')) {
        setTimeout(applyLimit, 0);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
